import { useEffect, useState } from "react";
import { getWorkerImg } from "services/firebase/firebase.service";

interface UseWorkerAvatarParams {
  readonly workerExternalId?: string | null;
  readonly isWorker?: boolean | null;
  readonly initialUrl?: string | null;
}

/**
 * Resolves worker avatar URL based on external id and worker type.
 */
export const useWorkerAvatar = (
  params: UseWorkerAvatarParams,
): string | null => {
  const [avatarUrl, setAvatarUrl] = useState<string | null>(
    params.initialUrl ?? null,
  );
  const isNonWorker = params.isWorker === false;

  useEffect(() => {
    if (isNonWorker || !params.workerExternalId) {
      setAvatarUrl(null);
      return;
    }

    if (params.initialUrl) {
      setAvatarUrl(params.initialUrl);
      return;
    }

    let isMounted = true;
    getWorkerImg(params.workerExternalId)
      .then((res: string | null) => {
        if (!isMounted) return;
        setAvatarUrl(res ?? null);
      })
      .catch(() => {
        if (!isMounted) return;
        setAvatarUrl(null);
      });

    return () => {
      isMounted = false;
    };
  }, [isNonWorker, params.initialUrl, params.workerExternalId]);

  return avatarUrl;
};
